<template>
  <div>
    <div class="d-flex justify-content-center mb-1">
      <b-spinner
        variant="success"
        span="Spinning"
        block
        v-if="loadingSpinner"
        style="width: 3rem; height: 3rem"
      >
      </b-spinner>
    </div>
    <section class="invoice-add-wrapper" v-if="!loadingSpinner">
      <b-row class="invoice-add">
        <!-- Col: Left (Invoice Container) -->
        <b-col cols="12" xl="9" md="8">
          <validation-observer v-slot="{ invalid }" ref="purchaseorder">
            <b-form @submit.prevent>
              <b-card no-body class="invoice-preview-card">
                <!-- Header -->
                <b-card-body class="invoice-padding pb-0">
                  <div class="d-flex flex-column flex-md-row align-items-start justify-content-between invoice-spacing">
                
                    <!-- Logo on the left -->
                    <div class="d-flex flex-column align-items-start me-md-3 mb-2 mb-md-0">
                      <div class="mb-2">
                        <Logo />
                      </div>
                      <div class="mb-1">
                        <CompanyName />
                      </div>
                      <div>
                        <Address />
                      </div>
                    </div>
                                    
                    <!-- Invoice Header Info on the right -->
                    <div class="invoice-number-date mt-md-0 mt-2 flex-grow-1">
                
                      <div class="d-flex align-items-center justify-content-md-end mb-1">
                        <h4 class="invoice-title">Purchase Invoice</h4>
                      </div>
                
                      <div class="d-flex align-items-center justify-content-md-end mb-1 ">
                        <span class="title">Date:</span>
                        <flat-pickr
                          v-model="issuedDate"
                          :config="config.wrap"
                          class="form-control invoice-edit-input ms-2"
                        />
                      </div>
                
                      <div class="d-flex align-items-center justify-content-md-end">
                        <validation-provider
                          rules="required"
                          v-slot="{ errors }"
                          name="Due Date"
                          vid="Due Date"
                        >
                          <div class="d-flex align-items-start">
                            <span class="title mt-1">Due Date:*</span>
                            <div class="ms-2">
                              <flat-pickr
                                v-model="dueDate"
                                :config="configDue.wrap"
                                placeholder="Due Date"
                                :class="[
                                  { 'is-invalid': errors.length },
                                  'form-control invoice-edit-input',
                                ]"
                              />
                              <small v-if="errors.length" class="text-danger">
                                {{ errors[0] }}
                              </small>
                            </div>
                          </div>
                        </validation-provider>
                      </div>
                
                      <div class="d-flex align-items-center justify-content-md-end mt-3">
                        <span class="title">Supplier Reference:</span>
                        <input
                          v-model="supplierReference"
                          type="text"
                          class="form-control invoice-edit-input ms-2"
                          placeholder="Enter Supplier Reference (Optional)"
                        />
                      </div>
                
                    </div>
                  </div>
                </b-card-body>
                

                <!-- Spacer -->
                <hr class="invoice-spacing" />

                <!-- Invoice Client & Payment Details -->
                <b-card-body class="invoice-padding pt-0">
                  <b-row class="invoice-spacing">
                    <!-- Col: Invoice To -->
                    <b-col cols="6" xl="6" class="mb-lg-1">
                      <h6 class="mb-2">Choose Supplier:*</h6>
                      <validation-provider
                        rules="required"
                        v-slot="{ errors }"
                        name="Supplier"
                        vid="supplierId"
                      >
                        <b-form-select
                          v-model="supplierId"
                          :options="optionsCustomer"
                          placeholder="select supplier"
                          @change="supplierSelected(supplierId)"
                        />
                        <small v-if="errors.length" class="text-danger">{{
                          errors[0]
                        }}</small>
                      </validation-provider>
                      <!-- Selected Client -->
                      <div v-if="whenSelected !== null" class="mt-1">
                        <b-card-text class="mb-25">
                          {{ whenSelected.name }}
                        </b-card-text>
                        <b-card-text class="mb-25">
                          {{ whenSelected.email }}
                        </b-card-text>
                        <b-card-text class="mb-25">
                          {{ whenSelected.address }}
                        </b-card-text>
                        <b-card-text class="mb-25">
                          {{ whenSelected.phoneNumber }}
                        </b-card-text>
                        <b-card-text class="mb-0">
                          {{ whenSelected.contactPerson }}
                        </b-card-text>
                      </div>
                    </b-col>
                    <b-col cols="6" xl="6" class="mb-lg-1">
                      <h6 class="mb-2">Choose Warehouse:*</h6>
                      <validation-provider
                        rules="required"
                        v-slot="{ errors }"
                        name="Warehouse"
                        vid="warehouseId"
                      >
                        <b-form-select
                          v-model="warehouseId"
                          placeholder="select warehouse"
                          :options="optionsWarehouse"
                        />
                        <small v-if="errors.length" class="text-danger">{{
                          errors[0]
                        }}</small>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </b-card-body>

                <!-- Items Section -->
                <b-card-body class="invoice-padding">
                  <div
                    ref="form"
                    class="repeater-form"
                    :style="{ height: trHeight }"
                  >
                    <b-row
                      v-for="(item, index) in invoiceData.items"
                      :key="index"
                      ref="row"
                      class="pb-2"
                    >
                      <!-- Item Form -->
                      <!-- ? This will be in loop => So consider below markup for single item -->
                      <b-col cols="12">
                        <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                        <!-- Form Input Fields OR content inside bordered area  -->
                        <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                        <div class="d-flex border rounded">
                          <b-row class="flex-grow-1 p-2">
                            <!-- Single Item Form Headers -->
                            <b-col cols="12" lg="6">
                              <label class="static-label">Items*</label>
                              <div
                                v-if="newProd"
                                class="d-flex justify-content-center"
                              >
                                <b-spinner variant="primary"></b-spinner>
                              </div>
                              <div v-else class="d-flex">
                                <div class="flex-grow-1 mr-1">
                                  <validation-provider
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="Item"
                                    :vid="`Item_${index}`"
                                  >
                                    <v-select
                                      v-model="item.id"
                                      :options="optionsProduct"
                                      label="itemTitle"
                                      :dir="
                                        $store.state.appConfig.isRTL
                                          ? 'rtl'
                                          : 'ltr'
                                      "
                                      :clearable="false"
                                      :searchable="true"
                                      :class="[
                                        { 'is-invalid': errors.length },
                                        'item-selector-title',
                                      ]"
                                      placeholder="Select Item"
                                      @input="
                                        (val) => updateItemForm(index, val)
                                      "
                                    >
                                      <template
                                        #option="{
                                          itemTitle,
                                          categoryName,
                                          subCategoryName,
                                        }"
                                      >
                                        <div
                                          style="
                                            display: flex;
                                            flex-direction: column;
                                          "
                                        >
                                          <span>{{ itemTitle }}</span>
                                          <span
                                            >{{ categoryName || "-" }} :
                                            {{ subCategoryName || "-" }}</span
                                          >
                                        </div>
                                      </template>
                                    </v-select>

                                    <small
                                      v-if="errors.length"
                                      class="text-danger"
                                      >{{ errors[0] }}</small
                                    >
                                  </validation-provider>
                                </div>

                                <div d-flex>
                                  <!-- Button Add Item -->
                                  <b-button
                                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                    v-b-modal.modal-addProduct
                                    variant="primary"
                                    size="md"
                                    class="mb-2"
                                  >
                                    +
                                  </b-button>
                                </div>
                              </div>
                            </b-col>
                            <b-col cols="12" lg="2">
                              <label class="static-label"
                                >Unit Price (Rs)</label
                              >
                              <validation-provider
                                rules="required|min_value:0|max_value:100000000"
                                v-slot="{ errors }"
                                name="Unit Price"
                                :vid="`UnitPrice_${index}`"
                              >
                                <b-form-input
                                  v-model="item.purchase"
                                  type="number"
                                  :max="100000000"
                                  @keypress="allowOnlyNumbers($event)"
                                />
                                <small v-if="errors.length" class="text-danger">
                                  {{ errors[0] }}
                                </small>
                              </validation-provider>
                            </b-col>
                            <b-col cols="12" lg="2">
                              <label class="static-label">VAT (%)</label>

                              <validation-provider  
                                name="VAT"
                                rules="required|between:0,100"
                                v-slot="{ errors }"
                              >
                                <b-form-input
                                  v-model="item.tax"
                                  type="number"
                                  min="0"
                                  max="100"
                                  @keypress="allowOnlyNumbers($event)"
                                  @wheel="allowOnlyNumbers($event)"
                                />

                                <small class="text-danger">
                                  {{ errors[0] ? "Please enter a valid VAT percentage." : "" }}
                                </small>
                              </validation-provider>
                            </b-col>
                            <b-col cols="12" lg="2">
                              <label class="static-label">Qty*</label>
                              <validation-provider
                                rules="required|min_value:1"
                                v-slot="{ errors }"
                                name="Quantity"
                                :vid="`Quantity_${index}`"
                              >
                                <b-form-input v-model="item.qty" @keypress="allowOnlyNumbers($event)"/>
                                <small
                                  v-if="errors.length"
                                  class="text-danger"
                                  >{{ errors[0] }}</small
                                >
                              </validation-provider>
                            </b-col>
                            <b-col cols="12" lg="2">
                              <div class="mb-1">
                                <b-button
                                  variant="danger"
                                  size="sm"
                                  @click="removeItem(index)"
                                >
                                  Remove
                                </b-button>
                              </div>
                            </b-col>
                            <b-col cols="12" lg="12">
                              <span class="d-inline d-lg-none"
                                >Description</span
                              >
                              <b-form-textarea
                                v-model="item.description"
                                class="mb-2 mb-lg-0"
                              />
                            </b-col>
                          </b-row>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    size="sm"
                    variant="primary"
                    @click="addNewItemInItemForm"
                  >
                    Add Item
                  </b-button>
                </b-card-body>

                <!-- Invoice Description: Total -->
                <b-card-body class="invoice-padding pb-0">
                  <b-row>
                    <!-- Col: Sales Persion -->
                    <b-col
                      cols="12" sm="6"
                   
                      class="mt-md-0 mt-3 d-flex align-items-center"
                      order="2"
                      order-md="1"
                    >
                      <span
                        for="invoice-data-sales-person"
                   
                        >Issuer:*</span
                      >
                      <validation-provider
                        rules="required"
                        v-slot="{ errors }"
                        name="Sales Person"
                        vid="Sales Person"
                      >
                        <b-form-select
                          v-model="salesPersonId"
                          :options="optionsSalesPerson"
                        />
                        <small v-if="errors.length" class="text-danger">{{
                          errors[0]
                        }}</small>
                      </validation-provider>
                    </b-col>

                    <!-- Col: Total -->
                    <b-col
                      cols="12" sm="6"
                      
                      class="mt-md-6 d-flex justify-content-end"
                      order="1"
                      order-md="2"
                    >
                      <div class="invoice-total-wrapper">
                        <div class="invoice-total-item">
                          <p class="invoice-total-title">Subtotal:</p>
                          <p class="invoice-total-amount">
                            {{ selectedCurrencySign }} {{ subTotal.toFixed(2) }}
                          </p>
                        </div>

                        <div class="invoice-total-item">
                          <p class="invoice-total-title">VAT:</p>
                          <p class="invoice-total-amount">
                            {{ selectedCurrencySign }} {{ VATtotal.toFixed(2) }}
                          </p>
                        </div>

                        <hr class="my-50" />
                        <div class="invoice-total-item">
                          <p class="invoice-total-title">Total:</p>
                          <p class="invoice-total-amount">
                            {{ selectedCurrencySign }} {{ finalTotal }}
                          </p>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </b-card-body>

                <!-- Spacer -->
                <hr class="invoice-spacing" />

                <!-- Note -->
                <b-card-body class="invoice-padding pt-0">
                  <span class="font-weight-bold">Note: </span>
                  <b-form-textarea v-model="note" />
                </b-card-body>
              </b-card>
            </b-form>
          </validation-observer>

          <validation-observer ref="addProduct">
            <!-- modal Add Item-->
            <b-modal
              id="modal-addProduct"
              :hide-footer="true"
              ref="addProductModal"
              centered
              title="Add Product"
            >
              <b-form @submit.prevent="handleProdSubmit">
                <b-row>
                  <b-col cols="12">
                    <b-form-group>
                      <label for="name">Name:</label>
                      <validation-provider
                        rules="required"
                        #default="{ errors }"
                        name="name"
                      >
                        <b-form-input
                          id="name"
                          type="text"
                          placeholder="Name"
                          v-model="prodName"
                          required
                        />
                        <small
                          v-if="errors.length"
                          class="text-danger text-end"
                          >{{ errors[0] }}</small
                        >
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <b-form-group>
                      <label for="qty">Quantity:</label>
                      <validation-provider
                        rules="required"
                        #default="{ errors }"
                        name="qty"
                      >
                        <b-form-input
                          id="qty"
                          type="number"
                          placeholder="Quantity"
                          v-model="prodQty"
                          required
                          @keypress="allowOnlyNumbersprod($event)"
                        />
                        <small
                          v-if="errors.length"
                          class="text-danger text-end"
                          >{{ errors[0] }}</small
                        >
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <b-form-group>
                      <b-form-checkbox v-model="prodInHouse" id="checkbox">
                        Product Manufactured InHouse
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="justify-content-end">
                  <!--    <b-col cols="3">
         Button Add Item 
       <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-secondary" @click="resetProductModal">
          Close
        </b-button> 
      </b-col> -->
                  <b-col cols="auto">
                    <!-- Button Add Item -->
                    <b-button
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="primary"
                      @click="addProduct"
                    >
                      Save
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </b-modal>
          </validation-observer>
        </b-col>

        <!-- Right Col: Card -->
        <b-col cols="12" md="4" xl="3" class="invoice-actions mt-md-0 mt-2">
          <!-- Action Buttons -->
          <b-card>
            <!-- Button: Print -->
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              block
              @click="addSalesOrder()"
              :disabled="loadingButton"
              :style="loadingButton ? { cursor: 'not-allowed' } : {}"
            >
              <b-spinner small v-if="loading"> </b-spinner>
              Save
            </b-button>
          </b-card>
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
import Logo from "@core/layouts/components/Logo.vue";
import Address from "@core/layouts/components/Address.vue";
import CompanyName from "@core/layouts/components/CompanyName.vue";
import { ref, onUnmounted } from "@vue/composition-api";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required, between } from "vee-validate/dist/rules";
import { fnSortingDropdown, allowOnlyNumbers } from "@/libs/customFn";
import { customLoader, numericValidation, customErrorMessage } from "@/libs/customFn";
import { mapActions, mapGetters } from "vuex";
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BButton,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BFormTextarea,
  BFormCheckbox,
  BPopover,
  VBToggle,
  BFormSelect,
  BSpinner,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { debounce } from "lodash";
import "@/libs/customValidation";

extend("required", {
  ...required,
  message: "{_field_} field is required",
});

// Register 'between' validator used in VAT validation
extend("between", between);

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BFormSelect,
    BCardText,
    BForm,
    BFormGroup,
    BSpinner,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormTextarea,
    BFormCheckbox,
    BPopover,
    flatPickr,
    vSelect,
    Logo,
    ValidationProvider,
    ValidationObserver,
    Address,
    CompanyName
  },
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },
  data() {
    return {
      optionsCustomer: [],
      loadingSpinner: false,
      whenSelected: [],
      optionsWarehouse: [],
      id: this.$route.params.id,
      optionsProduct: [],
      selectedCurrencySign: "Rs",
      optionsSalesPerson: [],
      salesPersonId: "",
      leadClientId: "",
      orderType: "",
      dueDate: "",
      warehouseId: "",
      issuedDate: Date.now(),
      supplierReference: "",
      note: "",
      config: {
        wrap: {
          wrap: true,

          minDate: new Date(),
        },
      },
      configDue: {
        wrap: {
          wrap: true,

          minDate: new Date(),
        },
      },
      taxOptions: [
        {
          value: 0,
          text: "0%",
        },
        {
          value: 1,
          text: "15%",
        },
      ],
      tax: 0,
      supplierId: null,
      ///order type
      optionsOrderType: [
        {
          value: null,
          text: "Please select an option",
        },
        // {
        //   value: 0,
        //   text: "Fixed Order",
        // },
        {
          value: 1,
          text: "Variable Order",
        },
        {
          value: 2,
          text: "OneOff Order",
        },
      ],
      optionsWarehouse: [],
      warehouseId: null,
      // add product modal
      prodName: "",
      prodQty: null,
      prodInHouse: false,
      newProd: false,
      loadingButton: false,
    };
  },
  mixins: [heightTransition],
  mounted() {
    this.initTrHeight();
  },
  computed: {
    ...mapGetters("supplierModule", {
      SupplierList: "suppliers",
      supplier: "supplierId",
      supplierLoading: "loading",
    }),
    ...mapGetters("purchaseInvoiceModule", {
      loading: "loading",
    }),
    ...mapGetters("warehouseModule", {
      warehouse: "warehouse",
      loading: "loading",
    }),
    ...mapGetters("productModule", {
      ProductList: "product",
      productLoading: "loading",
    }),
    ...mapGetters("rawmaterialModule", {
      RawMaterialList: "rawmaterials",
      materialLoading: "loading",
    }),
    ...mapGetters("salesPersonModule", {
      SalesPersonList: "salesperson",
      salesPersonLoading: "loading",
    }),
    ...mapGetters("warehouseModule", {
      warehouses: "warehouse",
      warehouseLoading: "loading",
    }),
    subTotal() {
      return parseFloat(this.totalCost);
    },
    VATtotal() {
      return parseFloat(this.salesTax);
    },
    salesTax() {
      let total = 0;

      this.invoiceData.items.forEach((item) => {
        let prodsalesTax = item.purchase * (parseFloat(item.tax || 0) / 100);
        total += prodsalesTax * item.qty;
      });

      let totalsalesTax = parseFloat(total.toFixed(2));

      if (isNaN(totalsalesTax)) {
        return 0;
      }
      return totalsalesTax;
    },
    finalTotal() {
      let total = this.subTotal + this.VATtotal;
      return total.toFixed(2);
    },
    totalCost() {
      let total = 0;
      this.invoiceData.items.forEach((item) => {
        let purchase = parseFloat(item.purchase).toFixed(2);
        let qty = parseFloat(item.qty).toFixed(2);
        total += parseFloat(purchase) * parseFloat(qty);
      });
      return total.toFixed(2);
    },
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  methods: {
    allowOnlyNumbersprod(event) {
  const charCode = event.which ? event.which : event.keyCode;

  if (
    charCode < 48 || charCode > 57
  ) {
    event.preventDefault();
  }
},
    ...mapActions("supplierModule", [
      "getSupplierListAction",
      "getSupplierByIDAction",
    ]),
    ...mapActions("productModule", [
      "getProductListAction",
      "addProductAction",
    ]),
    ...mapActions("rawmaterialModule", ["getRawMaterialListAction"]),
    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),
    ...mapActions("purchaseInvoiceModule", ["addPurchaseInvoicesAction"]),
    ...mapActions("warehouseModule", ["getWarehouseListAction"]),
    // add product modal start
    async resetProductModal() {
      this.prodName = "";
      this.prodQty = null;
      this.prodInHouse = false;
      this.newProd = false;
      this.$refs.addProductModal.hide();
    },
    async addProduct() {
      let isValid = await this.$refs.addProduct.validate();

      if (isValid) {
        let payload = {
          name: this.prodName,
          initialQuantity: this.prodQty,
          inHouseManufactured: this.prodInHouse,
        };

        try {
          await this.addProductAction({ product: payload });

          await this.$swal({
            title: "Products!",
            text: "You have successfully added the product!",
            icon: "success",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });

          this.newProd = true;

          this.$refs.addProductModal.hide();
          await this.loadProductList();
          await this.resetProductModal();
        } catch (ex) {
          await this.$swal({
            title: "Error!",
            html: ex.response?.data?.message || "Failed!",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
          await this.resetProductModal();
        }
      }
    },
    // add product modal end
    addNewItemInItemForm() {
      this.invoiceData.items.push(
        JSON.parse(JSON.stringify(this.itemFormBlankItem))
      );

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
        setTimeout(() => {
          this.$refs.form.style.overflow = null;
        }, 350);
      });
    },
    success() {
      this.$swal({
        title: "Success!",
        text: "You have successfully added the Purchase Invoice!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then(
        this.$router.push({
          name: "purchaseinvoices-list",
        })
      );
    },
    error(data) {
      let msg = null;
      if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        html: msg ?? " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    getErrorString(data) {
      let msg = null;
      if (data.errors) {
        let errors = data.errors;
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        for (var prop in errors) {
          if (
            Object.prototype.hasOwnProperty.call(errors, prop) &&
            prop !== "request"
          ) {
            msg += "<p>";
            msg += prop.replace("$.", "");
            msg += ": ";
            msg += errors[prop].toString().replace("$.", "");
            msg += "</p>";
          }
        }
        msg += "</div>";
      } else if (data.message) {
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        msg += data.message;
        msg += "</div>";
      }
      return msg;
    },

    removeItem(index) {
      this.invoiceData.items.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    addSalesOrder: debounce(function () {
      this.loadingButton = true;
      const loader = customLoader('Please wait while we save your order.');
      //let isValid = this.$refs.purchaseorder.validate();
      this.$refs.purchaseorder.validate().then((isValid) => {
        if (!isValid) {
          // Find the first invalid field
          const firstErrorField = this.$el.querySelector(".text-danger");
          if (firstErrorField) {
            // Scroll to the first invalid field
            firstErrorField.scrollIntoView({
              behavior: "smooth",
              block: "end",
              inline: "nearest",
            });
            // Set focus on the first invalid field
            firstErrorField.focus();
          }
          loader.close();
        } else {
          if (this.invoiceData.items.length === 0) {
            loader.close();
            customErrorMessage("Cannot add order without product");
            return false;
          } else {
            let payload = {
              status: 0,
              supplierId: this.supplierId,
              issueDate: new Date(this.issuedDate),
              salesPersonId: this.salesPersonId,
              paymentMethod: "string",
              dueDate: this.dueDate,
              supplierReference: this.supplierReference,
              discount: 0,
              subTotal: this.subTotal,
              tax: this.salesTax,
              total: this.finalTotal,
              currency: this.selectedCurrency,
              note: this.note,
              warehouseId: this.warehouseId,
              purchaseInvoiceItems: this.invoiceData.items.map((event) => ({
                itemId: event.value,
                itemName: event.itemTitle,
                cost: event.purchase,
                quantity: event.qty,
                price: event.purchase,
                discount: 0,
                description: event.description,
                isActive: true,
              })),
            };
            this.addPurchaseInvoicesAction(payload)
              .then(() => {
                loader.close();
                this.loadingButton = true;
                this.success();
              })
              .catch((error) => {
                loader.close();
                this.loadingButton = false;
                this.error(error);
              })
              .finally(() => {
                loader.close();
                this.loadingButton = false; // Set the loading flag to false after the API call is completed
              });
          }
        }
      });
      this.loadingButton = false;
    }, 300),

    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight);
      });
    },
    async supplierSelected(id) {
      await this.getSupplierByIDAction(id).then(() => {
        this.whenSelected = this.supplier;
      });
    },
    async loadProductList() {
      await this.getProductListAction(true).then(() => {
        this.ProductList.forEach((v, i) => {
          if (v.type !== 4) {
            this.optionsProduct.push({
              qty: 1,
              value: v.id,
              itemTitle: `${v.name}`,
              categoryName: v.categoryName || "-", // Default to "No Category" if null
              subCategoryName: v.subCategoryName || "-", // Default to "No Subcategory" if null
              cost: v.salePrice,
              tax: v.saleTaxPercentage,
              purchase: v.purchasePrice,
              profit: v.markUpPercentage,
              description: v.description,
            });
          }
        });
      });

      await this.getRawMaterialListAction().then(() => {
        this.RawMaterialList.forEach((v, i) => {
          this.optionsProduct.push({
            value: v.id,
            qty: 1,
            itemTitle: `${v.name}`,
            cost: v.salePrice,
            tax: v.saleTaxPercentage,
            purchase: v.purchasePrice,
            profit: v.markUpPercentage,
            description: v.description,
          });
        });
      });
      // filtering dupliactes from list of products and raw materials
      this.optionsProduct = this.optionsProduct.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.value === item.value)
      );
      this.optionsProduct = fnSortingDropdown(
        this.optionsProduct,
        "asc",
        "itemTitle"
      );
    },
  },
  async mounted() {
    this.loadingSpinner = true; // Set to true when the component is mounted
    setTimeout(() => {
      this.loadingSpinner = false; // Set to false after 4 seconds
    }, 6000);

    this.whenSelected = null;
    await this.getWarehouseListAction().then(() => {
      this.warehouse.map((v, i) =>
        this.optionsWarehouse.push({
          value: v.id,
          text: `${v.name}`,
        })
      );
    });
    this.optionsWarehouse = fnSortingDropdown(this.optionsWarehouse);

    await this.getSupplierListAction().then(() => {
      this.SupplierList.map((v, i) =>
        this.optionsCustomer.push({
          value: v.id,
          text: `${v.name}`,
        })
      );
    });
    this.optionsCustomer = fnSortingDropdown(this.optionsCustomer);

    await this.getSalesPersonListAction().then(() => {
      this.SalesPersonList.map((v, i) =>
        this.optionsSalesPerson.push({
          value: v.id,
          text: `${v.firstName}` + " " + `${v.lastName}`,
        })
      );
    });
    this.optionsSalesPerson = fnSortingDropdown(this.optionsSalesPerson);
    await this.loadProductList();
  },
  setup() {
    const itemFormBlankItem = {
      item: null,
      value: null,
      cost: 0,
      purchase: 0,
      qty: 1,
      tax: 0,
      profit: 0,
      description: "",
    };

    const invoiceData = ref({
      id: 5037,
      client: null,

      // ? Set single Item in form for adding data
      items: [JSON.parse(JSON.stringify(itemFormBlankItem))],

      salesPerson: "",
      note: "It was a pleasure working with you and your team. We hope you will keep us in mind for future freelance projects. Thank You!",
      paymentMethod: null,
    });

    const updateItemForm = (index, val) => {
      const {
        cost,
        qty,
        description,
        purchase,
        tax,
        profit,
        value,
        itemTitle,
      } = val;
      invoiceData.value.items[index].cost = cost ?? 0;
      invoiceData.value.items[index].cost = cost ?? 0;
      invoiceData.value.items[index].qty = qty;
      invoiceData.value.items[index].value = value;
      invoiceData.value.items[index].tax = tax || 15;
      invoiceData.value.items[index].profit = profit;
      invoiceData.value.items[index].purchase = purchase;
      invoiceData.value.items[index].description = description;
    };

    return {
      invoiceData,
      updateItemForm,
      itemFormBlankItem,
      allowOnlyNumbers
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.invoice-add-wrapper {
  .add-new-client-header {
    padding: $options-padding-y $options-padding-x;
    color: $success;

    &:hover {
      background-color: rgba($success, 0.12);
    }
  }
}
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "~@core/scss/base/components/variables-dark";

.form-item-section {
  background-color: $product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

#vs7__listbox {
  z-index: -1;
}

.repeater-form {
  // overflow: hidden;
  transition: 0.35s height;
}

.v-select {
  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}

.dark-layout {
  .form-item-section {
    background-color: $theme-dark-body-bg;

    .row .border {
      background-color: $theme-dark-card-bg;
    }
  }
}
</style>
